import { Link } from 'react-router-dom';

export default function CrumbLink({ to = '', children = null, name = '' }) {
  if (to) {
    return (
      <Link to={to} className="nsw-breadcrumb__link">
        {children || name}
      </Link>
    );
  } else {
    return <span>{children || name}</span>;
  }
}
